/*
    Create by BaiZhiming 2015-12-15
*/
'use strict';
angular.module('batChooseChnlModule', [])
    .controller('batChooseChnlCtrl', ['$scope', '$timeout', '$modalInstance', 'trsHttpService', 'chnlParams', 'trsspliceString', 'modalDialog', 'trsColumnTreeLocationService', 'editingCenterService', function ($scope, $timeout, $modalInstance, trsHttpService, chnlParams, trsspliceString, modalDialog, trsColumnTreeLocationService, editingCenterService) {
        init();
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
        $scope.showToggle = function (node) {
            if (node.HASCHILDREN === 'true' && node.CHILDREN.length === 0) {
                var params = {
                    'serviceid': 'mlf_mediasite',
                    'methodname': 'queryClassifyByChnl',
                    'ChannelId': node.CHANNELID,
                    'platform': chnlParams.platform,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    node.CHILDREN = data.CHILDREN;
                });
            }
        };
        $scope.getSuggestionsSc = function (viewValue) {
            var searchParams = {
                'serviceid': 'mlf_mediasite',
                'methodname': 'queryClassifyByName',
                'ChannelName': viewValue,
                'SiteId': chnlParams.siteid
            };
            return editingCenterService.getRecentUsageSources(viewValue, searchParams);
        };
        // 监控SUGGESTION
        $scope.$watch('searchChannel', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                searchSelected(newValue);
                $scope.searchChannel = '';
            }
        });
        $scope.confirm = function () {
            if ($scope.selectedNodes.length === 0) {
                modalDialog.alertType('请先选择栏目', '', 'warning', false);
                return;
            }
            $modalInstance.close({
                ChannelIds: trsspliceString.spliceString($scope.selectedNodes, 'CHANNELID', ','),
                selectedRadio: $scope.selectedRedio
            });
        };

        /**
         * [channelIsSelected description]
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        $scope.channelIsSelected = function (node) {
            var flag = false;
            var index;
            for (var i = 0; i < $scope.selectedNodes.length; i++) {
                if (node.CHANNELID === $scope.selectedNodes[i].CHANNELID) {
                    index = i;
                    flag = true;
                    break;
                }
            }
            return { flag: flag, index: index };
        };

        /**
         * [selectedNode description] 复选框选中节点
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        $scope.selectedNode = function (node) {
            var info = $scope.channelIsSelected(node);
            if (info.flag) {$scope.selectedNodes.splice(info.index, 1);} else {$scope.selectedNodes.push(node);}
        };

        /**
         * [cancelChannel description] 取消选中
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        $scope.cancelChannel = function (node) {
            $scope.selectedNodes.splice($scope.selectedNodes.indexOf(node), 1);
        };
        // 点击单选框
        $scope.chooseRadio = function (value) {
            $scope.selectedRedio = value;
        };
        // 单选框是否选中
        $scope.radioIsChecked = function (value) {
            return $scope.selectedRedio === value;
        };

        /**
         * [init description] 初始化
         * @return  {[type]}  [return description]
         */
        function init() {
            // 模态框标题初始化
            $scope.modalTitle = chnlParams.modalTitle;
            // 初始化附件单选框
            // $scope.radio = chnlParams.radio;
            // 初始化单选框选中状态
            if (angular.isDefined(chnlParams.radio) && angular.isDefined(chnlParams.radio.defaultValue)) {$scope.selectedRedio = chnlParams.radio.enumValue[chnlParams.radio.defaultValue];}
            // 树配置开始
            $scope.treeOptions = {
                nodeChildren: 'CHILDREN',
                dirSelectable: true,
                multiSelection: true,
                allowDeselect: false,
                isLeaf: function (node) {
                    return node.HASCHILDREN === 'false';
                }
            };
            // 树配置结束
            var params = {
                'serviceid': 'mlf_mediasite',
                'methodname': 'queryClassifyBySite',
                'SiteId': chnlParams.siteid,
                'platform': chnlParams.platform,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.SITEDESC = data.SITEDESC;
                $scope.dataForTheTree = data.CHILDREN;
            });
            $scope.status = {
                ifExpand: true
            };
        }

        /**
         * [searchSelected description] 搜索选中
         * @param   {[type]}  newValue  [newValue description]
         * @return  {[type]}            [return description]
         */
        function searchSelected(newValue) {
            var tempTree = { CHILDREN: angular.copy($scope.dataForTheTree) };
            delete $scope.dataForTheTree;
            $timeout(function () {
                $scope.expandedTest = [];
                trsColumnTreeLocationService.columnTreeLocation(chnlParams.platform, newValue.CHANNELID, tempTree, '', $scope.expandedTest, function (treeData, array, selectedNode) {
                    $scope.dataForTheTree = treeData.CHILDREN;
                    $scope.selectedNode(selectedNode);
                });
            });
        }
    }]);
